<app-registration-declaration-data
  *ngIf="currentForm"
  [model]="model"
  [producers]="model.producers"
  [storages]="model.storages"
  [inputForm]="currentForm"
  [isInstaller]="true"></app-registration-declaration-data>

<section>
  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="primary" id="modal-confirm-button" (click)="confirm()">Speichern</button>
  </div>
</section>
